/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description:
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储系统中的tabs数组
    tabs: [
      {
        id: '10000000000000000',
        title: '控制台',
        name: 'dashboard',
        changedName: 'dashboard',
        route: '/dashboard'
      }
    ],
    activeTabName: 'dashboard',
    // 当前激活的菜单id
    activeMenuId: '',

    currentLBtnList: [],
    currentFBtnList: [],
    currentVBtnList: [],
    editable: '',
    delable: ''
  },
  mutations: {
    setActiveTabName: function (state, tabName) {
      state.activeTabName = tabName
    },
    setListBtn: function (state, btns) {
      state.currentLBtnList = btns
    },
    setFormBtn: function (state, btns) {
      state.currentFBtnList = btns
    },
    setViewBtn: function (state, btns) {
      state.currentVBtnList = btns
    }
  },
  actions: {

  }
})
